import styled, { keyframes } from 'styled-components';

import { USER_TEMPLATE_OPTION_HIGHLIGHT_MS } from './utils';

export const OptionRow = styled.div`
  align-items: flex-start;
  display: flex;
  flex: 1;
  gap: 0.25rem;
  /* The default flex minimum is the label's width, which would widen the menu
     instead of letting the label wrap inside it. */
  min-width: 0;
`;

// Holds, then fades. Runs for exactly the highlight duration, so the timer that
// ends the highlight never removes the overlay mid-fade.
const highlightFade = keyframes`
  0%,
  35% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

// Covers the menu item, which is its containing block, beneath the row's text:
// the item is its own stacking context (UserTemplateOptionsStyles).
export const HighlightOverlay = styled.span`
  animation: ${highlightFade} ${USER_TEMPLATE_OPTION_HIGHLIGHT_MS}ms ease-out forwards;
  background-color: ${({ theme }) => theme.activeMenuItemBackgroundColor};
  inset: 0;
  pointer-events: none;
  position: absolute;
  z-index: -1;
`;

// Wraps inside the menu. A name with no spaces breaks too, so it cannot push the row past the cap.
export const OptionLabel = styled.span`
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
  white-space: normal;
`;

export const OptionActions = styled.span`
  align-items: center;
  display: inline-flex;
  flex-shrink: 0;
  margin-left: 0.5rem;
`;

// A span, not a button: a focusable element inside a menuitem stays in the
// accessibility tree whatever aria-hidden says, and is a nested control by ARIA's
// rules. These are pointer affordances; the keyboard path is the row's shortcuts.
export const IconAction = styled.span<{ $disabled: boolean }>`
  align-items: center;
  color: ${({ theme, $disabled }) => ($disabled ? theme.disabledTextColor : theme.headerColor)};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  display: inline-flex;
  font-size: 12px;
  height: 24px;
  justify-content: center;
  width: 24px;
`;
